import { Component, Input } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { createForm, FormType, subformComponentProviders } from 'ngx-sub-form';
import { UserUnitsModel } from 'src/app/core/components/user-units/user-units.model';
import { GasInfluxBase, InternalPressureProfileType, MudOverGasIPP } from '../../../models/internal-pressure-profile.model';
import { WellComponent } from 'src/app/wellbore-inputs/components/well-configuration/models/well-component';
import { PoreFrac } from 'src/app/perivis/models/poreFrac.model';

interface MudOverGasForm {
  type: InternalPressureProfileType.MUDOVERGAS;
  gasInfluxBase: GasInfluxBase;
}

@Component({
  selector: 'app-mud-over-gas',
  template: `
    <form [formGroup]="form.formGroup" class="flex flex-col">
      <app-gas-influx-base
        [formControlName]="form.formControlNames.gasInfluxBase"
        [userUnits]="userUnits"
        [currentString]="currentString"
        [fractureDepthDefault]="fractureDepthDefault"
        [influxDepthRange]="influxDepthRange"
        [nextStringMudWeight]="nextStringMudWeight"
        [tubulars]="tubulars"
        [fracPressures]="fracPressures"
        [porePressures]="porePressures"
        [wellheadDepth]="wellheadDepth"
        [isGasOverMud]="false"
      /></form>
  `,
  providers: subformComponentProviders(MudOverGasComponent),
  standalone: false
})
export class MudOverGasComponent {
  @Input() currentString: any;
  @Input() userUnits: UserUnitsModel;
  @Input() influxDepthRange: { min: number, max: number };
  @Input() fractureDepthDefault: number;
  @Input() nextStringMudWeight: number;
  @Input() tubulars: WellComponent[];
  @Input() fracPressures: PoreFrac[];
  @Input() porePressures: PoreFrac[];
  @Input() wellheadDepth: number;

  public form = createForm<MudOverGasIPP, MudOverGasForm>(this, {
    formType: FormType.SUB,
    formControls: {
      type: new UntypedFormControl(InternalPressureProfileType.MUDOVERGAS),
      gasInfluxBase: new UntypedFormControl(null, Validators.required)
      
    },
    toFormGroup: (obj: MudOverGasIPP | null): MudOverGasForm | null => {
      return {
        type: InternalPressureProfileType.MUDOVERGAS,
        gasInfluxBase: obj
      };
    },
    fromFormGroup: (formValue: MudOverGasForm): MudOverGasIPP | null => {
      return {
        type: InternalPressureProfileType.MUDOVERGAS,
        ...formValue.gasInfluxBase
      };
    }
  });
}
